<template>
  <div
    v-if="chartComponent"
    class="fill-height"
  >
    <component
      :is="chartComponent"
      :stats="teamStats"
      :loading="loading"
      :removable="removable"
      @remove="$emit('remove')"
    />
  </div>
</template>

<script>
import TeamSleepStatusTrendChart from '@/components/charts/implementation/TeamSleepStatusTrendChart.vue'
import TeamMoodStressTrendChart from '@/components/charts/implementation/TeamMoodStressTrendChart.vue'
import TeamGeneralMuscleSorenessTrendChart from '@/components/charts/implementation/TeamGeneralMuscleSorenessTrendChart.vue'

export default {
  name: 'TeamWellnessChart',
  components: {
    TeamSleepStatusTrendChart,
    TeamMoodStressTrendChart,
    TeamGeneralMuscleSorenessTrendChart
  },
  props: {
    teamStats: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    removable: {
      type: Boolean,
      default: false
    },
    chart: {
      type: Object,
      required: true
    }
  },
  computed: {
    chartComponent() {
      const componentMap = {
        SLQ_SLD_TREND: 'TeamSleepStatusTrendChart',
        MOO_STL_TREND: 'TeamMoodStressTrendChart',
        GMS_TREND: 'TeamGeneralMuscleSorenessTrendChart'
      }

      return componentMap[this.chart.key] || null
    }
  }
}
</script>
